/**
 * 额外关·终焉回廊 —— 单关长 boss 战（Extra 模式）。
 * 道中+中 boss 战约 70-80s（按满火力击杀估算；道中曲「回廊巡礼」82s 基本等长）：单一种星屑，变化全靠队形与节奏
 *（纵队→交叉→横排→环形→加速混编），每只必掉 P 保证到 boss 前满火力。
 * 中 boss 按东方 Extra 惯例由旧 boss 返场：s6Mid 彗星骑士。
 * bgm：道中 bgm_ex_stage「回廊巡礼」，boss 战切 bgm_boss「决战时刻」（与正篇各关同构）。
 */
import * as P from '../../game/patterns.js';
import { aimOf, fireTimer, exBig, s6Mid } from './bosses.js';

/** 星屑必掉 P（供给线：到 boss 前可喂满火力） */
const DROP_P = [{ type: 'P', weight: 1 }];

/** 星屑：缓降 + 6 连狙（Hard 基准密度，道中只有一种兵，热身 + 供给性质） */
function stardust(x, y, vy) {
  return {
    x, y, hp: 10, r: 12, spriteKey: 's6_star', scoreValue: 300, drops: DROP_P,
    script(e, dt, ctx) {
      e.y += vy * dt * 60;
      e.x += Math.sin(e.age * 1.8) * 0.5 * dt * 60;
      if (e.y > 8 && e.y < 360 && fireTimer(e, dt, 2.0)) {
        P.aimed(ctx.field, e.x, e.y, e.age, aimOf(ctx, e.x, e.y), { n: 1.75, speed: 2.6, color: 'star_yellow', jitter: 0.04 }); // Hard 基准迁移（输出不变）
      }
    },
  };
}

export default {
  id: 'extra', name: '额外关·终焉回廊', bg: 'bg6', bgm: 'ex_stage',
  *script(api) {
    const W = api.VIEW_W;
    yield { say: '额外关  终焉回廊' };
    yield { wait: 1.2 };

    // ---- 道中前段（~27s）：队形递进 ----
    // W1 纵队
    yield { wave: [0, 1, 2, 3, 4].map((i) => stardust(70 + i * 85, -24 - i * 36, 1.5)) };
    yield { wait: 3.5 };
    // W2 双侧平行夹击（正弦摆动，不交叉）
    yield {
      wave: [
        ...[0, 1, 2].map((i) => stardust(50 + i * 40, -24 - i * 32, 1.4)),
        ...[0, 1, 2].map((i) => stardust(W - 50 - i * 40, -24 - i * 32, 1.4)),
      ],
    };
    yield { wait: 3.5 };
    // W3 横排
    yield { wave: [0, 1, 2, 3, 4, 5].map((i) => stardust(60 + i * 72, -24, 1.6)) };
    yield { wait: 3.5 };
    // W4 环形（绕中心落）
    yield {
      wave: [0, 1, 2, 3, 4, 5, 6, 7].map((i) => {
        const a = (i / 8) * Math.PI * 2;
        return stardust(W / 2 + Math.cos(a) * 130, -40 + Math.sin(a) * 30, 1.5);
      }),
    };
    yield { wait: 3.5 };
    // W5 加速纵队 ×2
    yield {
      wave: [
        ...[0, 1, 2].map((i) => stardust(120 + i * 60, -24 - i * 40, 2.2)),
        ...[0, 1, 2].map((i) => stardust(W - 120 - i * 60, -24 - i * 40, 2.2)),
      ],
    };
    yield { wait: 3.5 };
    // W6 混编（横排 + 两侧斜切）
    yield {
      wave: [
        ...[0, 1, 2, 3].map((i) => stardust(100 + i * 93, -24, 1.7)),
        ...[0, 1].map((i) => stardust(40 + i * 50, -60 - i * 36, 1.3)),
        ...[0, 1].map((i) => stardust(W - 40 - i * 50, -60 - i * 36, 1.3)),
      ],
    };
    yield { clear: true };
    yield { wait: 1.0 };

    // ---- 中 boss：彗星骑士返场（东方 Extra 惯例） ----
    yield { boss: s6Mid() };
    yield { wait: 2.0 };

    // ---- 道中后段（~14s，节奏加快） ----
    // W7 双纵队加速
    yield {
      wave: [
        ...[0, 1, 2, 3].map((i) => stardust(90 + i * 55, -24 - i * 40, 2.4)),
        ...[0, 1, 2, 3].map((i) => stardust(W - 90 - i * 55, -24 - i * 40, 2.4)),
      ],
    };
    yield { wait: 3.0 };
    // W8 环形 + 中心纵队（道中收尾）
    yield {
      wave: [
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => {
          const a = (i / 10) * Math.PI * 2;
          return stardust(W / 2 + Math.cos(a) * 150, -40 + Math.sin(a) * 30, 1.8);
        }),
        ...[0, 1, 2].map((i) => stardust(W / 2, -24 - i * 44, 2.0)),
      ],
    };
    yield { clear: true };
    yield { wait: 1.0 };

    yield { boss: exBig() };
    yield { say: '额外关 CLEAR!!' };
  },
};
